// NOCTYVA cart value block. Shows the free items a Gum Armor tier earned,
// in the cart drawer and on the cart page. Data flows from /cart.js; the
// block re-renders on cart:update with guarded writes (no MutationObserver:
// an unguarded subtree observer froze this PDP once before).
(function () {
  var SINGLE = 44150833021002;
  var PACK3 = 43821248249930;
  var STRIPS = 44031391039562;

  var G1 = 'The 7-Day Gum Reset';
  var G2 = 'Fresh Breath Without the Burn';

  // CURRENT 2026-09-22 entitlements, PER UNIT (matches the live PDP buy box exactly - see
  // noctyva-products.yaml guides section before changing these numbers). Bottle/tin rows
  // scale with real cart quantity; guides + shipping are flat per order, not per-unit
  // (unverified whether repeat orders re-earn guides - left flat rather than guessed).
  var TIERS = {
    pack3: {
      head: 'Included FREE with your order over $200 in value',
      unitRows: [
        { label: 'free bottle', unitValue: 49.00, icon: 'bottle', qtyOf: 'main', suffix: 'FREE' },
        { label: 'tin of Probiotic Strips', unitValue: 39.00, icon: 'tin', qtyOf: 'gift', suffix: 'FREE' }
      ],
      guides: [G1, G2],
      shipping: true
    },
    sub: {
      head: 'Included FREE with your order',
      unitRows: [
        { label: 'Subscribe & Save discount', unitValue: 10.00, icon: null, qtyOf: 'main', suffix: 'OFF' }
      ],
      guides: [G1],
      shipping: true
    }
    // single: intentionally absent - no free items, panel does not render for a single-only cart.
  };
  var GUIDE_VALUE = 12.50;
  var SHIPPING_VALUE = 4.95;

  function tierOf(cart) {
    var tier = null, mainQty = 0, giftQty = 0;
    (cart.items || []).forEach(function (it) {
      if (it.variant_id === PACK3) { tier = pick(tier, 'pack3'); mainQty += it.quantity; }
      else if (it.variant_id === SINGLE && it.selling_plan_allocation) { tier = pick(tier, 'sub'); mainQty += it.quantity; }
      else if (it.variant_id === STRIPS) { giftQty += it.quantity; }
    });
    return tier ? { tier: tier, mainQty: mainQty, giftQty: giftQty } : null;
  }
  var RANK = { sub: 1, pack3: 2 };
  function pick(a, b) { return !a || RANK[b] > RANK[a] ? b : a; }

  var SVGNS = 'http://www.w3.org/2000/svg';
  function svgPath(d, fill, stroke, width) {
    var p = document.createElementNS(SVGNS, 'path');
    p.setAttribute('d', d);
    p.setAttribute('fill', fill);
    if (stroke) { p.setAttribute('stroke', stroke); p.setAttribute('stroke-width', width); }
    return p;
  }
  function circle(cx, cy, r, fill) {
    var c = document.createElementNS(SVGNS, 'circle');
    c.setAttribute('cx', cx); c.setAttribute('cy', cy); c.setAttribute('r', r);
    c.setAttribute('fill', fill);
    return c;
  }
  function rect(x, y, w, h, rx, stroke) {
    var el = document.createElementNS(SVGNS, 'rect');
    el.setAttribute('x', x); el.setAttribute('y', y); el.setAttribute('width', w); el.setAttribute('height', h);
    el.setAttribute('rx', rx); el.setAttribute('fill', 'none'); el.setAttribute('stroke', stroke); el.setAttribute('stroke-width', '1.6');
    return el;
  }

  function icon(type) {
    var w = document.createElement('span');
    w.className = 'ntv-cartvalue__icon';
    var svg = document.createElementNS(SVGNS, 'svg');
    svg.setAttribute('width', '18');
    svg.setAttribute('height', '18');
    svg.setAttribute('viewBox', '0 0 24 24');
    svg.setAttribute('aria-hidden', 'true');
    if (type === 'truck') {
      svg.appendChild(svgPath('M2 6.5h11v9H2z', 'none', '#a4161a', '1.6'));
      svg.appendChild(svgPath('M13 10h4l4 3.2v2.3h-8z', 'none', '#a4161a', '1.6'));
      svg.appendChild(circle(6, 17.7, 1.7, '#a4161a'));
      svg.appendChild(circle(17, 17.7, 1.7, '#a4161a'));
    } else if (type === 'tin') {
      svg.appendChild(svgPath('M9 2.5h6v2.5H9z', '#a4161a', null, null));
      svg.appendChild(rect(6.5, 5, 11, 16, 2, '#a4161a'));
      svg.appendChild(svgPath('M6.5 9.5h11', 'none', '#a4161a', '1.4'));
    } else if (type === 'bottle') {
      svg.appendChild(svgPath('M10 2h4v3.5l2 2.5v12a1.5 1.5 0 0 1-1.5 1.5h-5A1.5 1.5 0 0 1 8 20V8l2-2.5z', 'none', '#a4161a', '1.6'));
      svg.appendChild(svgPath('M8.3 10.5h7.4', 'none', '#a4161a', '1.4'));
    } else {
      svg.appendChild(svgPath('M12 5.2c-1.8-1.3-4.6-1.3-7-.5v14c2.4-.8 5.2-.8 7 .5c1.8-1.3 4.6-1.3 7-.5v-14c-2.4-.8-5.2-.8-7 .5z', 'none', '#a4161a', '1.6'));
      svg.appendChild(svgPath('M12 5.2v14', 'none', '#a4161a', '1.4'));
    }
    w.appendChild(svg);
    return w;
  }

  function row(iconType, label, value) {
    var r = document.createElement('div');
    r.className = 'ntv-cartvalue__row';
    var s1 = document.createElement('span');
    s1.className = 'ntv-cartvalue__label';
    if (iconType) s1.appendChild(icon(iconType));
    s1.appendChild(document.createTextNode(label));
    var s2 = document.createElement('span');
    s2.textContent = value;
    r.appendChild(s1);
    r.appendChild(s2);
    return r;
  }

  function money(n) { return '$' + n.toFixed(2); }

  function build(tierKey, mainQty, giftQty) {
    var t = TIERS[tierKey];
    var box = document.createElement('div');
    box.className = 'ntv-cartvalue';
    box.setAttribute('data-ntv-tier', tierKey);
    box.setAttribute('data-ntv-qty', mainQty + ':' + giftQty);

    var total = 0;
    var rowEls = [];
    t.unitRows.forEach(function (r) {
      var qty = r.qtyOf === 'gift' ? giftQty : mainQty;
      if (qty <= 0) return;
      var lineValue = r.unitValue * qty;
      total += lineValue;
      var label = qty > 1 ? (qty + ' ' + r.label + 's') : ('1 ' + r.label);
      rowEls.push(row(r.icon, label, money(lineValue) + ' ' + r.suffix));
    });
    t.guides.forEach(function (g) { total += GUIDE_VALUE; rowEls.push(row('book', g, money(GUIDE_VALUE) + ' FREE')); });
    if (t.shipping) { total += SHIPPING_VALUE; rowEls.push(row('truck', 'Free shipping', money(SHIPPING_VALUE) + ' FREE')); }

    var h = document.createElement('div');
    h.className = 'ntv-cartvalue__head';
    h.textContent = tierKey === 'pack3'
      ? (t.head) // "over $200" is a deliberate rounded PDP-matching phrase, not the literal rows sum
      : (t.head + ', ' + money(total) + ' in value');
    box.appendChild(h);
    rowEls.forEach(function (el) { box.appendChild(el); });
    return box;
  }

  function targets() {
    var out = [];
    var drawer = document.querySelector('.cart-drawer__content');
    if (drawer) out.push(drawer);
    var page = document.querySelector('.cart-page__more-blocks');
    if (page) out.push(page);
    return out;
  }

  function place(state) {
    var key = state ? state.tier + ':' + state.mainQty + ':' + state.giftQty : null;
    targets().forEach(function (host) {
      var existing = host.querySelector('.ntv-cartvalue');
      if (!state) {
        if (existing) existing.parentNode.removeChild(existing);
        return;
      }
      var existingKey = existing ? existing.getAttribute('data-ntv-tier') + ':' + existing.getAttribute('data-ntv-qty') : null;
      if (existingKey === key) return;
      if (existing) existing.parentNode.removeChild(existing);
      var box = build(state.tier, state.mainQty, state.giftQty);
      var items = host.querySelector('.cart-drawer__items');
      if (items && items.nextSibling) host.insertBefore(box, items.nextSibling);
      else if (items) host.appendChild(box);
      else host.insertBefore(box, host.firstChild);
    });
  }

  var inflight = false;
  function refresh() {
    if (inflight) return;
    inflight = true;
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) { inflight = false; place(tierOf(cart)); })
      .catch(function () { inflight = false; });
  }

  function schedule() {
    [300, 900, 1800].forEach(function (ms) { setTimeout(refresh, ms); });
  }

  document.addEventListener('cart:update', schedule);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', schedule);
  else schedule();
})();
